// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadButton__icon-f9af34 {
  fill: var(--base-60);
}

.UploadButton__input-f6d0cd {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/Appearance/ChatBackgroundSelection/UploadButton/UploadButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".icon {\n  fill: var(--base-60);\n}\n\n.input {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `UploadButton__icon-f9af34`,
	"input": `UploadButton__input-f6d0cd`
};
module.exports = ___CSS_LOADER_EXPORT___;
